import common from 'store/modules/common/api'

export const api = {
  getEntity: (id) => common.httpClient.get(`/api/services/app/OrderProcessing/Get?id=${id}`, common.options()).then(r => common.processResponse(r)),
  createBottles: (entity) => common.httpClient.post(`/api/services/app/OrderProcessing/CreateBottles`, entity, common.options(120000)).then(r => common.processResponse(r))
}
